var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAcessoFacil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.702,
    height: 62.366,
    viewBox: "0 0 57.702 62.366",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2, .cls-5 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3 {\r\n        stroke: currentColor;\r\n        stroke-linecap: round;\r\n        stroke-width: 4px;\r\n      }\r\n\r\n      .cls-1, .cls-3 {\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: currentColor;\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke: none;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Acesso_Facil",
    "data-name": "Icon Acesso Facil",
    transform: "translate(2.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_150",
    "data-name": "Caminho 150",
    className: "cls-1",
    d: "M5842.332,5993.224c-16.312,11.749-8.156,27.507-1.659,32.207s21.564,5.806,28.476-8.156",
    transform: "translate(-5832.784 -5968.304)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_151",
    "data-name": "Caminho 151",
    className: "cls-1",
    d: "M5856.542,5965.144l4.285,26.54h19.628l6.635,20.181,6.634-2.626",
    transform: "translate(-5840.636 -5959.022)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_14",
    "data-name": "Linha 14",
    className: "cls-2",
    x1: 13.39,
    transform: "translate(18.556 23.098)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_37",
    "data-name": "Elipse 37",
    className: "cls-3",
    transform: "translate(10.332)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 6.448,
    cy: 6.448,
    r: 6.448
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 6.448,
    cy: 6.448,
    r: 4.448
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcessoFacil);
export default __webpack_public_path__ + "static/media/AcessoFacil.6f2be214e3b966a656bb9cb3c35a0fe2.svg";
export { ForwardRef as ReactComponent };